import _ from 'lodash';
const alwaysInclude = Symbol('alwaysInclude');
const checkValueForInclusion = val => !(val === null || val === '' || val === undefined);
export const splitEnumArrayByField = ({ original, key }) => {
    const res = {};
    let fieldKey = '';
    original = original || [];
    original.forEach(field => {
        fieldKey = field[key];
        res[fieldKey] = field;
    });
    return res;
};
export const groupEnumArrayByField = ({ original, key }) => {
    const res = {};
    let fieldKey = '';
    let existing;
    original = original || [];
    original.forEach(field => {
        fieldKey = field[key];
        existing = res[fieldKey];
        if (Array.isArray(existing)) {
            existing.push(field);
        }
        else {
            res[fieldKey] = [field];
        }
    });
    return res;
};
export const mergeEnumArrayByField = ({ original, split, key, inclusionKey = alwaysInclude, }) => {
    const numValues = Object.keys(split).length;
    const res = new Array(numValues);
    let runningIndex = 0;
    let fieldKey;
    original = original || [];
    original.forEach((field, i) => {
        fieldKey = field[key];
        const splitField = split[fieldKey];
        if (splitField) {
            const inclusionCheckValue = splitField[inclusionKey];
            const shouldBeIncluded = checkValueForInclusion(inclusionCheckValue);
            if (inclusionKey === alwaysInclude || shouldBeIncluded) {
                res[runningIndex] = {
                    ...splitField,
                    [key]: fieldKey,
                };
            }
            delete split[fieldKey];
        }
        else {
            res[runningIndex] = field;
        }
        runningIndex++;
    });
    for (const [newKey, newField] of Object.entries(split)) {
        res[runningIndex] = {
            ...newField,
            [key]: newKey,
        };
        runningIndex++;
    }
    return _.compact(res);
};
//# sourceMappingURL=enumArrays.js.map